import { css } from 'lit';
import { IxIconButton } from './IxIconButton.js';

export class IxIconButtonStyled extends IxIconButton {
  static override styles = css`
    :host {
      display: flex;

      --md-icon-button-state-layer-height: calc(
        var(--md-icon-button-icon-size) * 1.65
      );
      --md-icon-button-state-layer-width: calc(
        var(--md-icon-button-icon-size) * 1.65
      );
    }

    :host([small]) {
      --md-icon-button-state-layer-height: calc(
        var(--md-icon-button-icon-size) * 1.2
      );
      --md-icon-button-state-layer-width: calc(
        var(--md-icon-button-icon-size) * 1.2
      );
    }

    :host(.cancel) {
      --md-sys-color-on-surface-variant: var(--ix-button-cancel-color);
    }
  `;
}

customElements.define('ix-icon-button', IxIconButtonStyled);
